module.exports = __webpack_public_path__ + "static/media/python_android.1ce76561.jpg";